module.exports = __webpack_public_path__ + "b71c5b640ad3a1ee9a760b8ebeb18c12.pdf";